import React from 'react';
import { Form, Select as ASelect } from 'antd';
import { FormItemWrapper } from '../../common/form-item-wrapper';
import { renderFormItemExtra } from '../../common/tooltip';
export var Select = function (props) {
    var controlSchema = props.controlSchema;
    var required = controlSchema.required, tooltip = controlSchema.tooltip, extra = controlSchema.extra, name = controlSchema.name, label = controlSchema.label, placeholder = controlSchema.placeholder, _a = controlSchema.options, options = _a === void 0 ? [] : _a;
    return (React.createElement(FormItemWrapper, { schema: controlSchema }, function (_a) {
        var hidden = _a.hidden, disabled = _a.disabled, initialValue = _a.initialValue;
        return (React.createElement(Form.Item, { name: name, label: label, initialValue: initialValue, tooltip: tooltip, extra: renderFormItemExtra(extra), required: required, hidden: hidden },
            React.createElement(ASelect, { disabled: disabled, placeholder: placeholder }, options.map(function (option) {
                var title = option.title, value = option.value;
                return (React.createElement(ASelect.Option, { key: value.toString(), value: value }, title));
            }))));
    }));
};
